import i18n from 'i18n'
import * as React from "react"
import { SelectSeeker } from "ui-seeker/core"

const OPTIONS = [
    { label: 'Lowest rate', value: '1' },
    { label: 'Flexible rate', value: '2' },
]

// Display-only: value ('1'/'2') es identidad; solo se traduce el texto.
const RATE_KEY = { '1': 'common:filters.lowestRate', '2': 'common:filters.flexibleRate' }

export default function SelectPriceType({...props}) {

    const myProps = {
        placeholder: i18n.t('common:filters.selectType'),
        formatOptionLabel: opt => i18n.t(RATE_KEY[opt?.value] || '', { defaultValue: opt?.label }),
        firstSelect: true,
        options: OPTIONS,
        icon: {icon: 'chart-line'},
        ...props
    }

    return <SelectSeeker {...myProps} />
}